import React, { useState, useContext, useEffect, useRef } from "react";
import "./shareInvoiceQrcode.scss";
import { useHistory } from "react-router-dom";

// material ui
import { Button, Grid, IconButton } from "@material-ui/core";
import Box from '@mui/material/Box';
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
// localizations
import { withTranslation, useTranslation, Trans } from "react-i18next";
// redux
import { useSelector, useDispatch } from 'react-redux';
import QRCodeStyling from "qr-code-styling";
import ContentCopyIcon from "../../Assets/images/ContentCopyIcon.svg";
import TextField from '@mui/material/TextField';
import { RWebShare } from "react-web-share";
import InputAdornment from '@mui/material/InputAdornment';

const qrCode = new QRCodeStyling({
  width: 200,
  height: 200,

  dotsOptions: {
    color: "#000",
    type: "dot"
  },
  imageOptions: {
    crossOrigin: "anonymous",
    margin: 20
  }
});

function ShareInvoiceQrcode({ type, invoiceDetails }) {
  const history = useHistory();
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [url, setUrl] = useState("");
  const [fileExt, setFileExt] = useState("png");
  const ref = useRef(null);



  const handleClickOpenQrCode = () => {
    setOpen(true);
  };

  const handleCloseQrCode = () => {

    appDispatch({
      type: "setShareInvoiceQrcode",
      shareInvoiceQrcode: false,
    });
  };

  useEffect(() => {
    qrCode.append(ref.current);
  }, [handleClickOpenQrCode]);

  useEffect(() => {
    qrCode.update({
      data: url
    });
  }, [url]);

  const onUrlChange = (event) => {
    event.preventDefault();
    setUrl(event.target.value);

  };

  useEffect(() => {


    setUrl(window.location.href);



  }, []);



  const handleCopyText = () => {
    var copyText = document.getElementById("myInput");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
  }

  return (
    <>
      {/* <Grid className="centerColumn" item xs={12} md={6}> */}
        <div id="mySidenav" className={`shareInvoiceQrcode col-md-12 ${appState.langValue == "ar" ? "shareInvoiceQrcodeArabic" : " "
          }`}>
          {/* <a href="javascript:void(0)" className="closebtn" onClick="closeNav()">&times;</a> */}
          <div className="container-fluid classForQrcodeStyling content px-4 pb-3">
            <div className="d-flex justify-content-end">
            <IconButton onClick={() => appDispatch({
             type: "setShareInvoiceQrcode",
             shareInvoiceQrcode: false,
              })} className="classForSvgColor mt-2" >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L12 10.9393L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L13.0607 12L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L12 13.0607L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L10.9393 12L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z" fill="#22282F" />
              </svg>

            </IconButton>
            </div>
   
            <h1 className={`text-center ${appState.langValue === "ar" ? " familyGraphikArabic800 " : " familyPoppins600 "
              }`}
            >{type === "in" && invoiceDetails.status == "Partial" ? t("invoice.Lets-Split") : t("invoice.invoice")}</h1>


            <div className=" py-3 MscBannerQrcodeInner"> <div className="row px-2 ">

            </div>
              <div className="App  ">
                <div className="d-flex justify-content-center" ref={ref} />
                <div className=" d-flex  mt-3 inputWrapper" style={styles.inputWrapper}>
                  <div className="d-flex align-items-center w-100">
                    <TextField id="myInput"


                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">

                            <IconButton onClick={handleCopyText} onmouseout="outFunc()" size="small">
                              <img src={ContentCopyIcon} alt="ContentCopyIcon" />

                            </IconButton>

                          </InputAdornment>
                        ),
                      }}
                      label={t("invoice.Invoice-URL")} variant="outlined" className="inputBox " value={url} onChange={onUrlChange} style={styles.inputBox} />
                  </div>
                </div>
              </div>




            </div>





            <div className="bottomBtn">

              <RWebShare
                data={{
                  text: "invoice",
                  url: url,
                  title: "Share your Invoice",
                }}
                onClick={() => console.log("shared successfully!")}
              >
                <Button className={` py-3 px-4 confirmBtn mt-3 justify-content-center ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
                  }`}

                > <span >{t("invoice.share")}</span>  </Button>
              </RWebShare>

              <Button onClick={handleCloseQrCode} className={` py-3 px-4 mt-3 deletebtn justify-content-center ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
                }`}

              > <span >{t("invoice.Cancel")}</span>  </Button>
            </div>



          </div>
        </div>
      {/* </Grid> */}


    </>


  );
}


const styles = {
  inputWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  inputBox: {
    width: "100%",
    margin: "0px"

  }
};
export default withTranslation()(ShareInvoiceQrcode);